@for (kritiek of record.kritiekMetCat; track $index) {
    @if (kritiek[0] !== 'capacity') {
        <div class="kritiek mb-2">{{ kritiek[1] }}</div>
    }
}

@if (isLeverancier) {
    @if (record.gelockt) {
        <div class="text-danger mb-2">Deze invulling is gesloten. Neem desgewenst contact op met de
            afdeling planning.
        </div>
    } @else if (record.leverancierlock === 'auto') {
        <div class="text-danger mb-2">De invulling sluit
            op {{ record.leverancierSluitmoment }}
        </div>
    }
}

@for (ppi of record.personeel_planitem; track ppi.trackerId; let num = $index) {
    <div class="personeelselectcontainer" [class.firsttoomuch]=" num === (record.capacity || 0) ">
        @if (onzichtbaarVoorLeverancier(ppi)) {
            <input type="text" disabled class="form-control"
                   value="(Ander personeel)">
        } @else if (alleenLezenVoorUitlener(ppi)) {
            <input type="text" disabled class="form-control"
                   [value]="personeel(ppi.personeelvast_id).naam + ' (andere werkmaatschappij)'">
        } @else {
            <div class="personeelkeuze">
                @if (ppi._tags.info && ppi.personeelvast_id) {
                    <div class="personeelrow_statisch">
                        <div class="personeeltekst"
                             [class.font-italic]="isAndereWM(ppi.personeelvast_id)"
                             [class.certificering-verlopen]="personeelfit(ppi.personeelvast_id)?.certificeringVerlopen"
                             [attr.data-functionfit]="personeelfit(ppi.personeelvast_id)?.functionfit ?? ''"
                             [title]="personeelTitle(personeelfit(ppi.personeelvast_id))">
                            <span>{{ personeel(ppi.personeelvast_id)?.naam }}</span>

                            @if (isAndereWM(ppi.personeelvast_id)) {
                                - <span>(externe werkmaatschappij)</span>
                            }
                            @else if (ppi.leverancier_id) {
                                @if (isLeverancier) {
                                    @if (ppi.leverancier_id === api.userdata.leverancier_id) {
                                        - <span>{{ leverancier(ppi.leverancier_id)?.naam }}</span>
                                    } @else {
                                        - <span>(andere leverancier)</span>
                                    }
                                }
                                @else {
                                    - <span>{{ leverancier(ppi.leverancier_id)?.naam }}
                                        @if (ppi.leverancier_id !== personeel(ppi.personeelvast_id)?.leverancier_id) {
                                            (alternatieve leverancier)
                                        }
                                    </span>
                                }
                            }

                            @if (personeel(ppi.personeelvast_id)?.telefoonnummer?.length) {
                                - {{ personeel(ppi.personeelvast_id)?.telefoonnummer }}
                            }
                            @if (personeel(ppi.personeelvast_id)?.woonplaats?.length) {
                                - {{ personeel(ppi.personeelvast_id)?.woonplaats }}
                            }
                            @if (personeel(ppi.personeelvast_id)?.email?.length) {
                                - {{ personeel(ppi.personeelvast_id)?.email }}
                            }
                        </div>
                        <div class="personeelbuttons">
                            <button class="btn btn-outline-primary btn-small" type="button"
                                    title="Verberg info"
                                    (click)="ppi._tags.info = false"><span
                                    class="fas fa-info-circle"></span></button>
                        </div>
                    </div>
                } @else {
                    <div class="input-group">
                        <ng-select class="form-control" bindValue="id" [name]="'ppi_'+ num"
                                   [appendTo]="dropdownContainer"
                                   [disabled]="readonly || (! magPersoneelEdit)"
                                   [(ngModel)]="ppi.personeelvast_id"
                                   (ngModelChange)="kiesPersoneel(ppi)">

                            @for (pdata of fittedPersoneel; let pnum = $index; track pdata.p.id) {
                                @if (isExterneBewerker && pnum > 0 && fittedPersoneel[pnum - 1].leverancierfit !== pdata.leverancierfit) {
                                    <ng-option [disabled]="true">-----</ng-option>
                                }
                                <ng-option [value]="pdata.p.id"
                                           *ngIf="noDuplicatePersoneel(pdata.p.id,ppi)">
                                    <div
                                            class="personeelrow"
                                            [class.font-italic]="isAndereWM(pdata.p.id)"
                                            [class.certificering-verlopen]="pdata.certificeringVerlopen"
                                            [attr.data-functionfit]="pdata.functionfit"
                                            [title]="personeelTitle(pdata)">{{ pdata.p.naam }}
                                        <ng-container *ngIf="pdata.p.telefoonnummer?.length">
                                            ({{ pdata.p.telefoonnummer }})
                                        </ng-container>
                                        @if (pdata.certificeringVerlopen) {
                                            <span class="certificeringmelding">– certificering verlopen</span>
                                        }
                                    </div>
                                </ng-option>
                            }
                        </ng-select>
                        <div class="input-group-append">
                            <button class="btn btn-outline-primary btn-small" type="button"
                                    title="Toon info"
                                    [disabled]="!ppi.personeelvast_id"
                                    (click)="ppi._tags.info = !ppi._tags.info"><span
                                    class="fas fa-info-circle"></span></button>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
    @if ((!ppi._tags.info) && volLezen && ppi.personeelvast_id && (! isAndereWM(ppi.personeelvast_id))  && (! alleenLezenVoorUitlener(ppi)) && personeel(ppi.personeelvast_id)?.groep !== 'Personeel' && (!isLeverancier)) {
        <div class="ml-5">
            @if (isLeverancierReadonly(ppi)) {
                <input type="text" disabled class="form-control"
                       [value]="leverancierNaam(ppi.leverancier_id)">
            } @else {
                <div class="input-group">
                    <select [name]="'leverancier_' + num" class="form-control" required
                            [disabled]="readonly || (! magPersoneelEdit)"
                            [(ngModel)]="ppi.leverancier_id" (ngModelChange)="stopPPIEdit(ppi)">
                        @for (leverancier of lookups['leverancier']; track $index) {
                            @if (passendeLeverancier(leverancier, ppi)) {
                                <option [ngValue]="leverancier.id">{{ leverancier.naam }} {{ leverancier.id === personeel(ppi.personeelvast_id)?.leverancier_id ? '(standaard leverancier)' : (leverancier.id === ppi.leverancier_id ? '(alternatieve leverancier)' : '') }}
                                    @if (!leverancier.exact_id) {
                                        NIET BOEKBAAR
                                    }
                                </option>
                            }
                        }
                    </select>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" title="Zet standaard"
                                [disabled]="readonly || (! magPersoneelEdit) || ppi.leverancier_id === personeel(ppi.personeelvast_id)?.leverancier_id"
                                (click)="ppi.leverancier_id = personeel(ppi.personeelvast_id)?.leverancier_id"><span
                                class="fas fa-undo"></span>
                        </button>
                    </div>
                </div>
            }
        </div>
    }
}
<div style="height: 10em"></div>
